module.exports = __webpack_public_path__ + "static/media/Attachments.962fa182.svg";